import { render, staticRenderFns } from "./FooterMain2.vue?vue&type=template&id=73b9c07e&scoped=true&"
import script from "./FooterMain2.vue?vue&type=script&lang=js&"
export * from "./FooterMain2.vue?vue&type=script&lang=js&"
import style0 from "./FooterMain2.vue?vue&type=style&index=0&id=73b9c07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9c07e",
  null
  
)

export default component.exports